import {Component, inject} from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'app-progress-dialog',
    templateUrl: './progress-dialog.component.html',
    styleUrls: ['./progress-dialog.component.scss'],
    standalone: false
})
export class ProgressDialogComponent {
  // Injections
  public data: {descriptorText: string, count: number} = inject(MAT_DIALOG_DATA);
}
